var _defs, _g, _g2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSi2(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_10",
    "data-name": "Group 10",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 44.349,
    height: 47,
    viewBox: "0 0 44.349 47",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: -0.07,
    y1: -1.562,
    x2: 0.99,
    y2: -1.562,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#00bcf9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0251c7"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_6",
    "data-name": "Group 6",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3",
    "data-name": "Path 3",
    d: "M209,136.817a11.383,11.383,0,0,0-9.771,5.729,31.941,31.941,0,0,0-3.6,8.948,39.94,39.94,0,0,0-1.1,9.369,36.61,36.61,0,0,0,2.558,13.823c1.831,4.392,4.568,7.651,7.947,8.752,3.9,1.27,9.925-.9,15.819-4.48,9.174-5.57,18.025-14.549,18.025-19.268a3.3,3.3,0,0,0-.044-.546c0-.009,0-.016,0-.025a16.1,16.1,0,0,0-2.426-5.711C231.112,145.13,218.654,136.417,209,136.817Z",
    transform: "translate(-194.525 -136.804)",
    fill: "url(#linear-gradient)"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Group_9",
    "data-name": "Group 9",
    transform: "translate(9.584 14.608)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8",
    "data-name": "Group 8"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7",
    "data-name": "Group 7"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4",
    "data-name": "Path 4",
    d: "M234.511,170.633a.179.179,0,0,0-.076.15,12.349,12.349,0,0,1-.091,2.086,13.772,13.772,0,0,1-1.206,4.188,13.418,13.418,0,0,1-2.546,3.712,12.562,12.562,0,0,1-6.459,3.6,13.766,13.766,0,0,1-2.623.31,13.268,13.268,0,0,1-7.531-2.02c-.025-.016-.051-.033-.11-.074a9.468,9.468,0,0,0,4.708-.646,9.281,9.281,0,0,0,2.238-1.306,4.723,4.723,0,0,1-4.381-3.259,4.681,4.681,0,0,0,2.019-.066.178.178,0,0,0,.068-.025,4.738,4.738,0,0,1-3.059-2.161,4.607,4.607,0,0,1-.687-2.5,4.685,4.685,0,0,0,2.094.578,4.757,4.757,0,0,1-1.934-2.857,4.7,4.7,0,0,1,.5-3.41,13.455,13.455,0,0,0,9.7,4.917c-.025-.185-.051-.351-.075-.519a4.618,4.618,0,0,1,.688-3.074,4.508,4.508,0,0,1,3.191-2.12,4.579,4.579,0,0,1,4.122,1.306.236.236,0,0,0,.252.076,9.421,9.421,0,0,0,2.73-1.055c.025-.009.041-.017.068-.025,0-.009.007-.009.024-.009a4.779,4.779,0,0,1-2.01,2.564,9.22,9.22,0,0,0,2.622-.7c0,.009.009.009.016.017-.184.234-.352.477-.543.712A9.012,9.012,0,0,1,234.511,170.633Z",
    transform: "translate(-213.868 -166.062)",
    fill: "#fff"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSi2);
export default __webpack_public_path__ + "static/media/si2.f4405befe69120f143ee790db56c18a1.svg";
export { ForwardRef as ReactComponent };